export default "__VITE_ASSET__B11raawu__"